import { render, staticRenderFns } from "./AttestationReport.vue?vue&type=template&id=fedadbf0&scoped=true&"
import script from "./AttestationReport.vue?vue&type=script&lang=js&"
export * from "./AttestationReport.vue?vue&type=script&lang=js&"
import style0 from "./AttestationReport.vue?vue&type=style&index=0&id=fedadbf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedadbf0",
  null
  
)

export default component.exports